<template>
    <div id="historical-upload-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title h5" id="uploadTitle">Upload Historical Health Insurance Claim File</div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <div v-if="client" class="form-group form-row p-0 m-0">
                        <label class="col-sm-3">Client</label>
                        <span class="col">{{ client.name }}</span>
                    </div>
                    <div class="mt-3 font-italic text-muted"><small>Drop or select historical claims spreadsheet.</small></div>
                    <form method="post" action="#" files="true" enctype="multipart/form-data" id="historical-dropzone" class="dropzone"> 
                        <input type="hidden" name="_token" :value="csrf">
                    </form>
                </div>                        
            </div>
        </div>
    </div>     
</template>

<script>
export default {
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            client: null
        }
    },
    methods: {
        show: function (client) {
            this.client = client;
            $('.dropzone').get(0).dropzone.options.url = '/ajax/clients/' + client.id + '/historical/claims';
            $('#historical-upload-modal').modal('show');
        }
    },
    created() {

        eventHub.$on('show-historical-upload', this.show);

        Dropzone.options.historicalDropzone = {
            maxFilesize: 100, // files 100MB or less this matches php.ini (upload_max_filesize and post_max_size)
            addRemoveLinks: true,
            timeout: 15000,
            autoProcessQueue: true,
            uploadMultiple: false,
            parallelUploads: 1,
            maxFiles: 1,
            thumbnailHeight: 32,
            // acceptedFiles: "application/pdf,text/plain,image/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            init: function() {

                this.on('sending', function(file, xhr, formData) {
                    $('#historical-upload-modal').modal('hide');
                    $("#spinner").modal('show');
                });

                this.on('complete', function(file) {
                    this.removeAllFiles(true);
                    $("#spinner").modal('hide'); 
                    $('#historical-upload-modal').modal('hide');
                });             
            },
            success(files, response) {
                
                if (response.message) {
                    let level = response.level;
                    let title = response.title;
                    let message = response.message;
                    toastr[level](message, title, { timeOut: 5000, positionClass: "toast-top-full-width", closeButton: true });
                }                
            },
            error(file, response) {

                toastr['error'](response, 'Error', { timeOut: 5000, positionClass: "toast-top-full-width", closeButton: true });
            }
        }         
    },
    beforeDestroy() {

        eventHub.$off('show-historical-upload');
    }    
}
</script>

<style scoped>

</style>